import { Collection } from 'modules/core/lib/mobx-rest'

import Category from 'modules/expenses/store/models/Category'

class Categories extends Collection<Category> {
  get cacheKey(): string {
    return 'categories'
  }

  model() {
    return Category
  }
}

const singleton: Categories = new Categories()

export default singleton
